import { heroEquipment } from "../HeroEquipment";

export const zwierzoludzie = {
  heroes: {
    "Herszt zwierzoludzi": {
      id: 0,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 80,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 3, 4, 4, 2, 4, 1, 7],
        Maksymalna: [6, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: [
        "Dowódca",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Za mną!",
        "Zasadzka",
      ],
      exp: 20,
      skills: [0, 3, 4, 5],
    },
    "Szaman zwierzoludzi": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur Rykowca"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Szaman,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 3, 3, 4, 1, 4, 1, 6],
        Maksymalna: [6, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: [
        "Mag (Dziedzina Chaosu albo Dziedzina Dziczy)",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Zasadzka",
      ],
      exp: 11,
      skills: [0, 4, 5],
    },
    Bestigor: {
      id: 2,
      startingEquipment: ["Sztylet", "Topór bojowy/Nadziak"],
      cost: 55,
      number: 2,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 3, 4, 4, 1, 3, 1, 7],
        Maksymalna: [6, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: ["Nadrzewni drapieżcy", "Ranger"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Centigor: {
      id: 3,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 90,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [8, 4, 3, 4, 4, 1, 2, 1, 7],
        Maksymalna: [9, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: [
        "Alkoholizm",
        "Bycza szarża",
        "Centaur",
        "Nadrzewni drapieżcy",
        "Ranger",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    Ungor: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Ungor,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 3, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Berserk",
        "Chorążowie & sygnaliści",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Stan niższy",
        "Zasadzka",
        "Żywa tarcza",
      ],
    },
    Grabieżcy: {
      id: 5,
      startingEquipment: ["Sztylet","Łuk krótki"],
      cost: 25,
      number: 5,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Ungor,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 3, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Berserk",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Stan niższy",
        "Światowiec",
        "Zasadzka",
        "Zwiadowca",
        "Żywa tarcza",
      ],
    },
    Harpia: {
      id: 6,
      startingEquipment: ["Broń naturalna (szybki)"],
      cost: 35,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 0, 4, 3, 1, 4, 2, 6],
        Maksymalna: [4, 4, 0, 4, 3, 1, 4, 2, 6],
      },
      rules: [
        "Głód krwi",
        "Lot",
        "Nadrzewni drapieżcy",
        "Rozmiar rzondzi",
        "Zwierzę",
      ],
    },
    Gor: {
      id: 7,
      startingEquipment: ["Sztylet", "Topór bojowy/Nadziak"],
      cost: 45,
      number: 5,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 3, 3, 4, 1, 3, 1, 6],
        Maksymalna: [6, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: ["Berserk", "Nadrzewni drapieżcy", "Ranger", "Zasadzka"],
    },
    "Wilczarz Chaosu": {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 20,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 4, 0, 4, 3, 1, 3, 1, 5],
        Maksymalna: [7, 4, 0, 4, 3, 1, 3, 1, 5],
      },
      rules: ["Rączy", "Zasadzka", "Zwierzę"],
    },
    Minotaur: {
      id: 9,
      startingEquipment: ["Broń wielka"],
      cost: 200,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado Zwierzoludzi"].Minotaur,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 3, 4, 4, 3, 4, 2, 8],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód krwi",
        "Głód trzewi",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Przepastne trzewia",
        "Strach",
        "Stygmat Chaosu",
        "Tempy",
        "Wielkolud",
      ],
    },
    Rydwan: {
      id: 10,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Tuskgor: [7, 3, 0, 3, "-", "-", 2, 1, 3],
        "Tuskgor ": [7, 3, 0, 3, "-", "-", 2, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan", "Szarża dzików"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Zbrojne stado Zwierzoludzi",
  nature: "Chaotyczna",
  armyRules: [
    "Niewolnicy ciemności",
    "Oko Chaosu",
    "Podatek",
    "Rozrzutność",
    "Znak Chaosu",
  ],
  mercenaries: [],
};
